import styled from 'styled-components';

export const Wrapper = styled.div`

`
export const EventCard =styled.div`
    height:300px;
`
export const Span = styled.span`
    font-size:15px;
    color:gray;
    display:flex;
    align-items:center;
    white-space:nowrap;
    font-family: sans-serif;


    `;

export const Image= styled.img`
    width:100%;
    height:220px;
    object-fit:cover;
`